// check wingspanHQ/search-configuration
export enum PayerPayeeEngagementSearchableStatus {
  NotSignedUp = "NotSignedUp",
  NotEligible = "NotEligible",
  Eligible = "Eligible",
  Inactive = "Inactive"
}
